module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_38.65211a2d.png";